import React from "react";
import { Typography, Input, Tooltip, Button, Tag, Checkbox } from "antd";
import { AuditOutlined } from "@ant-design/icons";
import FullName from "../../../components/tables/FullName";
import ApprovedStatusSelect from "../../../components/util/ApprovedStatusSelect";
import moment from "moment";
const { Text } = Typography;

const getDayCenterColumns = (
  intl,
  handleChanges,
  changes,
  showModal,
  hasEditorPermission,
  hasPatientsPermission,
  location
) => [
  {
    title: intl.formatMessage({
      id: "app.patients.fullname",
    }),
    dataIndex: "patient",
    render(text) {
      const name = text.surename + " " + text.first_name;

      return hasPatientsPermission ? (
        <FullName
          record={text}
          customLocation={
            location.pathname.split("/").slice(0, -1).join("/") +
            "/patients/" +
            text.id
          }
        />
      ) : (
        <Text>{name}</Text>
      );
    },
    sortIndex: "surename",
    sortDirections: ["descend", "ascend"],
    ellipsis: true,
    width: "200px",
  },
  {
    title: intl.formatMessage({ id: "app.patients.day_in_week" }),
    dataIndex: "date",
    render(text) {
      const date = moment(text);
      return <Text>{date.format("dddd")}</Text>;
    },
    sortDirections: ["descend", "ascend"],
    ellipsis: true,
    width: "90px",
  },
  {
    title: intl.formatMessage({ id: "app.patients.day_center_plan" }),
    dataIndex: "day_center_plan",
    render(text) {
      return text.map((day) => {
        const dayName = moment().day(day).format("dddd");
        return <Tag style={{ marginTop: "4px" }}>{dayName}</Tag>;
      });
    },
  },

  {
    title: intl.formatMessage({
      id: "app.patients.present",
    }),
    dataIndex: "patient_id",
    width: "120px",
    render(text, record) {
      const approvedStatus =
        changes[`${text}_${record.order_id}`]?.day_center_approved_info;
      return (
        <ApprovedStatusSelect
          popupContainer={document.getElementById("dayCenterTableRef")}
          value={approvedStatus}
          onChange={(val) => {
            handleChanges(
              text,
              record.order_id,
              "day_center_approved_info",
              val
            );
            handleChanges(text, record.order_id, "approved", val !== 4);
          }}
          disabled={record?.event?.prospectus_id || !hasEditorPermission}
        />
      );
    },
  },

  {
    title: intl.formatMessage({
      id: "app.patients.day_center_half_day",
    }),
    dataIndex: "day_center_half_day",
    width: "120px",
    render(text, record) {
      return (
        <Checkbox
          checked={
            changes[`${record.patient_id}_${record.order_id}`]
              ?.day_center_half_day
          }
          onChange={(e) => {
            const val = e.target.checked;
            handleChanges(
              record.patient_id,
              record.order_id,
              "day_center_half_day",
              val
            );
          }}
          style={{ margin: "20px 0" }}
          disabled={record?.event?.prospectus_id || !hasEditorPermission}
        />
      );
    },
  },

  {
    title: intl.formatMessage({
      id: "app.patients.comment",
    }),
    dataIndex: "comment",
    render(text, record) {
      return (
        <Input
          style={{ minWidth: "120px" }}
          value={
            changes[`${record.patient_id}_${record.order_id}`]?.comment ?? text
          }
          disabled={!hasEditorPermission}
          onChange={(e) =>
            handleChanges(
              record.patient_id,
              record.order_id,
              "comment",
              e.target.value
            )
          }
        />
      );
    },
  },
  {
    title: intl.formatMessage({
      id: "app.scheduling.table.status",
    }),
    dataIndex: "approved",
    width: "80px",
    render(text, record) {
      return record?.event?.prospectus_id ? (
        <Tooltip
          title={intl.formatMessage(
            { id: "app.scheduling.table.prospectus_serial" },
            { prospectus_serial: record?.event?.prospectus_serial_number }
          )}
        >
          <Tag color="processing">
            {intl.formatMessage({
              id: "app.scheduling.table.invoiced",
            })}
          </Tag>
        </Tooltip>
      ) : record.approved ? (
        <Tag color="success">
          {intl.formatMessage({
            id: "app.scheduling.table.verified",
          })}
        </Tag>
      ) : null;
    },
  },
  {
    title: intl.formatMessage({
      id: "app.patients.actions",
    }),
    responsive: ["md"],
    width: "100px",
    render(text, record) {
      return (
        <div style={{ display: "flex" }}>
          <Tooltip
            title={intl.formatMessage({
              id: "app.patients.go_to_patient",
            })}
          >
            <Button
              type="text"
              icon={<AuditOutlined />}
              onClick={() => showModal(record)}
            />
          </Tooltip>
        </div>
      );
    },
  },
];

export default getDayCenterColumns;
